import React from 'react';
import { Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/gluestack/text';
import { useCommunity } from '~/hooks/useCommunity';
import { useOpenWebPage } from '~/hooks/useOpenWebPage';

const PHOTO_POLICY_URL =
  'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/9e045c7a-d475-45c7-8f3f-90779ada1949/article/10551306';

export function PhotoPolicyNotice() {
  const { t } = useTranslation();
  const community = useCommunity();
  const openWebPage = useOpenWebPage();
  const isFerzu = community?.code === 'ferzu';

  return (
    <Pressable onPress={() => openWebPage(PHOTO_POLICY_URL)}>
      <Text size="xs" className="text-typography-500">
        <Text size="xs" underline className="text-primary-500">
          {t('photos.policyLink', 'Read our photo policy')}
        </Text>
        <Text size="xs" italic className="text-typography-500">
          {isFerzu
            ? `. ${t('photos.artworkNoticeFerzu', 'Artwork must be credited. AI-generated images are not allowed.')}`
            : `. ${t('photos.artworkNotice', 'AI-generated images must be captioned as such.')}`}
        </Text>
      </Text>
    </Pressable>
  );
}
